<ng-container *ngIf="(userInfo && !loading); else waiting">
    <div class="row">
         <!-- sezione ricerca -->
         <app-advanced-search [customSearch]="advSearch.getConfigAdv()" (callSearch)="searchParams($event)" (callButton)="callButton($event)"></app-advanced-search>
         <div *ngIf="primaRicerca">
            <h5 title="Rimuovere i filtri di ricerca renderà la ricerca molto lenta e potrebbe non restituire risultati in quanto la richiesta va in timeout">Ricerca di default attivata - vengono mostrati i documenti dell'anno corrente {{this.anno}}</h5>
        </div>
         <hr>
    </div>

<ng-container *ngIf='dataTable; else waiting'>
    <div class="row" style="margin-bottom: 10px;" *ngIf="dataTable.length>0">
        <div [ngClass]="{'col' : innerWidth! > 767, 'col-12': innerWidth! <= 767}" class="text-center text-md-left">
           <!-- <div style="float: right; display: flex; align-items: start;">-->
            <div class="d-inline-block" style="float:left">
                <button type="button" class="btn btn-light btn-sm mb-1 w-xs-100" style="margin-right: 5px"
                    (click)='downloadSelected()'><i class="bi bi-download"></i> {{'invoices.button.downloadSelected' | translate}}</button>
                <button type="button" class="btn btn-light btn-sm mb-1 w-xs-100" style="margin-right: 5px;"
                    (click)='setDownload(2)'><i class="bi bi-file-check"></i> {{'invoices.button.alreadyDownloaded' | translate}} </button>
                <button type="button" class="btn btn-light btn-sm mb-1 w-xs-100" style="margin-right: 5px; "
                    (click)='setDownload(0)'><i class="bi bi-file-earmark-arrow-down"></i> {{'invoices.button.toDownload' | translate}} </button>
                <button type="button" class="btn btn-light btn-sm mb-1 w-xs-100" style="margin-right: 5px" 
                    (click)='downloadCSV()'><i class="bi bi-file-earmark-excel"></i> {{'invoices.dropdown.downloadSelected' | translate}}</button>
                <div ngbDropdown class="d-inline-block"  style="margin-right: 5px;">
                    <button class="btn btn-light btn-sm mb-1  w-xs-100" id="dropdownBasic2" ngbDropdownToggle
                        style='margin: 0px'>
                        <i class="bi bi-file-earmark-pdf"></i> {{'invoices.button.generateAndDownloadSelectedPDF' |
                        translate}}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
                        <button ngbDropdownItem (click)="downloadPDF('')">{{'invoices.dropdown.assoFormat' | translate}}</button>
                        <button ngbDropdownItem (click)="downloadPDF('min');">{{'invoices.dropdown.minFormat' | translate}}</button>
                        <button ngbDropdownItem (click)="downloadPDFCombi('');">{{'invoices.dropdown.allAssoFormat' | translate}}</button>
                        <button ngbDropdownItem (click)="downloadPDFCombi('min');">{{'invoices.dropdown.allMinFormat' | translate}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <div class="row justify-content-between"  style="margin-bottom: 10px; margin-top:10px">
            <div class='col-auto' style="display: flex; flex-direction: row;">
                <label  class="form-check-label" style='margin-right: 5px;'>{{'general.show' | translate}}</label>
                  <div class="dm7Select" >
                      <div class="select-side">
                        <img src="assets/icone_varie/arrow_down.svg">
                      </div>
                      <app-select class="selectDm7" 
                              [options]="pages" [key]="'key'" [value]="'key'"
                              [placeholder]="'placeholder.select' | translate" [addNull]="false" [selectedKey]="params.get('pageSize')"
                              (change)="changePageSize($event.key)"></app-select>
                  </div>
                  <label  class="form-check-label">{{'paginator.rows' | translate}}</label>
              </div>
            <div class= 'col-4' style="float: right;">
                <app-paginator *ngIf="paginator" [config]="paginator" (refresh)="getDataTable()" (next)="next()" (prev)="prev()" (setPage)="setPage($event)"></app-paginator> 
            </div>
        </div>
        <div class="row justify-content-between" style="margin-bottom: 10px; margin-top:10px">
            <div class='col-auto' style="float: right;">
                    {{file_selected}} {{'invoices.selectedFiles' | translate}} <button *ngIf="file_selected > 0"
                        type="button" class="btn btn-sm mb-1 w-xs-100" style="margin-left: 10px "
                        (click)='deselectAll()'><i class="bi bi-file-earmark-excel"></i>
                        {{'invoices.undoSelection' | translate}}</button>
            </div>
        </div>
        <div  *ngIf="dataTable.length>0; else noRes">
            <div >
                <table  class="table table-sm">
                    <thead>
                        <tr>
                            <th scope="col" style="max-width: 40px; width: 30px;"></th>
                            <th scope="col" style=" max-width: 40px; width: 30px;"><input type="checkbox" style="margin-left:-4px" class="form-check-input" id="predef" [(ngModel)]="allSelected" (ngModelChange)="setSelected()"></th>
                            <th class="d-print-none" scope="col" style="max-width: 60px; width: 60px;">{{'invoices.table.tipo' | translate}}</th>
                            <th scope="col">{{'invoices.table.num' | translate}}</th>
                            <th class="d-print-none" scope="col">{{'invoices.table.sdi' | translate}}</th>
                            <th scope="col" style="max-width: 100px; width: 100px;">{{'invoices.table.date' | translate}}</th>
                            <th scope="col" colspan="2">{{'invoices.table.sender' | translate}}</th>                      
                            <th scope="col">{{'invoices.table.amount' | translate}}</th>
                            <!--<th class="d-print-none" scope="col">{{'invoices.table.expireDate' | translate}}</th>-->
                            <th scope="col">{{'invoices.table.dateTimeReceived' | translate}}</th>
                            <th class="d-print-none" scope="col">{{'invoices.table.status' | translate}}</th>
                            <!--<th class="d-print-none" scope="col">{{'invoices.table.notific' | translate}}</th>-->
                            <th scope="col" colspan="1" class="d-print-none" (click)="sort('date_created')">{{'invoices.table.fileName' | translate}}
                                <br/>{{'invoices.table.dateCreated' | translate}} </th>
                            <!--<th class="d-print-none" scope="col">{{'invoices.table.fileName' | translate}}</th>
                            <th class="d-print-none" scope="col">{{'invoices.table.dateCreated' | translate}}</th>-->
                            <th scope="col" style="max-width: 60px; width: 60px;">{{'invoices.table.actions' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of dataTable; index as i;">
                            <td><div style='display: flex; flex-direction: column;'>
                                <img [src]="'assets/icone_varie/' + (item.download==1 ? 'check_1' : item.download==0? 'email': 'download') + 
                                (item.workflow_state_code === 'draft'? '_rosso.svg' : '.svg') " 
                                [ngbTooltip]= "(getTooltip(item) | translate)"
                                 style='width:16px;height:auto; margin-bottom : 10px'>
     
                             <!--<ng-container *ngIf='getTag(item.tags).length>0'>
                                 <img [ngbTooltip]= "getTag(item.tags)[1]"[src]="'assets/icone_varie/tag_' +getTag(item.tags)[0] +'.svg' "
                                 style='width:16px;height:auto'>
                             </ng-container>-->
                                </div>
                            </td>
                            <td>
                                
                                <div class="form-group form-check">
                                    <input type="checkbox" class="form-check-input"  id="predef" [(ngModel)]="item.selected" (ngModelChange)="checkAllSelected()" (click)='$event.stopPropagation();'>
                                </div>
                            </td>
                            <td class="d-print-none" [ngStyle]="{'color':  item.tipo_fattura == 'TD04' ? 'red' : 'black'}">{{item.tipo_fattura}}</td>
                            <td (click)='openPreview(item.id, item.file_name, i)'>{{item.numero_fattura}}</td>
                            <td class="d-print-none" (click)='openPreview(item.id, item.file_name, i)'>{{item.identificativo_sdi==''? 'n/a' : item.identificativo_sdi}}</td>
                            <td (click)='openPreview(item.id, item.file_name, i)'>{{stringToDate(item.data_fattura!, "DD-MM-YYYY")}}</td>
                            <td  (click)='openPreview(item.id, item.file_name, i)' colspan="2">{{item.denominazione}}</td>
                            <td (click)='openPreview(item.id, item.file_name, i)' title="Imponibile: {{item.imponibile}}, imposta: {{item.imposta}}">{{formatNumber(item.importo)}}</td>
                            <!--<td class="d-print-none" (click)='openPreview(item.id, item.file_name, i)'>{{item.DataScadenzaFattura}}</td>-->
                            
                            <td>{{item.data_ricezione == null ? 'n/a' : stringToDate("" + item.data_ricezione, "DD-MM-YYYY HH:mm:ss")}}</td>
                            <td class="d-print-none">{{item.stato}}</td>
                            <!--<td class="d-print-none"><div ngbDropdown class="d-inline-block">
                                <card class='ghost' id="dropdownBasic1" ngbDropdownToggle (click)='$event.stopPropagation(); getNotifications(item.relateds)'>
                                    {{item.relateds.length}} 
                                    <img [src]="'assets/icone_varie/notifica' + (item.workflow_state_code=='draft'? '_rosso.svg' : '.svg')"
                                    style='width:15px' >
                                </card>
                                <div ngbDropdownMenu aria-labelledby="dropdownBasic1" *ngIf='item.relateds.length>0'>
                                    <button *ngFor ='let n of notifications' ngbDropdownItem (click)="$event.stopPropagation();openNotification(item.id, n.id, n.file_name)">{{n.file_name}}</button>
                                   
                                </div>
                            </div></td>-->
                           
                            <td class="d-print-none" style='word-break: break-all;'>{{item.file_name}}
                                <img *ngIf="item.conservato == 1" title="Conservato" [src]="'assets/icone_varie/seal.svg' " style='width:16px; height:auto'>
                                <!--<img *ngIf="item.e_signed" title="Fattura firmata digitalmente" [src]="'assets/icone_varie/signed.svg' " style='width:16px; height:auto'>-->
                                <!--<img *ngIf="getAllegati(item.tags)" title="La fattura contiene allegati" [src]="'assets/icone_varie/paperclip.svg' " style='width:16px; height:auto'>
                            </td>
                       
                            <td class="d-print-none">--><br/>{{stringToDate(item.data_creazione, "DD-MM-YYYY HH:mm:ss")}}</td>
                            <td class='btnCol'>
                                <div ngbDropdown class="d-inline-block">
                                    <button class="btn btn-primary mydropdown" id="dropdownBasic1" ngbDropdownToggle (click)='$event.stopPropagation()'>
                                        <img src="assets/icone_varie/azione.svg" style="width: 25px;">
                                    </button>
                                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                        <button ngbDropdownItem (click)="downloadFile('file', item.id, i)">{{'invoices.dropdown.downloadFile' | translate}}</button>
                                    
                                        <button ngbDropdownItem (click)="downloadFile('xml', item.id, i)">{{'invoices.dropdown.downloadXml' | translate}}</button>
                                        <button ngbDropdownItem (click)="downloadFile('allegati', item.id, i)">{{'invoices.dropdown.downloadAllegati' | translate}}</button>
                                        <button ngbDropdownItem (click)="showPreviewMinisteriale(item.id, item.file_name, i); $event.stopPropagation()">{{'invoices.dropdown.preview' | translate}}</button>
                                        <button *ngIf="item.can_accept_refuse" ngbDropdownItem (click)="esitaFattura(item.id); $event.stopPropagation()">{{'invoices.dropdown.esitate' | translate}}</button>
                                    
                                    </div>
                                </div>
                            </td>
                        
                            
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
    <br>

    


</ng-container>
<ng-template #noRes>
    <div>
      <ngb-toast [autohide]="false" class="warning">
          <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">
          {{'general.noResults' | translate}}
      </ngb-toast>
    </div>
  </ng-template>


</ng-container>
<ng-template #waiting>
    <app-loading></app-loading>
</ng-template>